import React from "react";

const Envelope = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-envelope"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-envelope"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M23.954,5.542,15.536,13.96a5.007,5.007,0,0,1-7.072,0L.046,5.542C.032,5.7,0,5.843,0,6V18a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V6C24,5.843,23.968,5.7,23.954,5.542Z" />
      <path d="M14.122,12.546l9.134-9.135A4.986,4.986,0,0,0,19,1H5A4.986,4.986,0,0,0,.744,3.411l9.134,9.135A3.007,3.007,0,0,0,14.122,12.546Z" />
    </svg>
  );
};

export default Envelope;
